import L from 'leaflet';

const stopIcon = new L.Icon({
    iconUrl: require('../leaflet/icons/stopIcon.png'),
    iconAnchor: new L.Point(12.5, 12.5),
    iconSize: new L.Point(25, 25)
});

const selectedStopIcon = new L.Icon({
    iconUrl: require('../leaflet/icons/selectedStopIcon.png'),
    iconAnchor: new L.Point(12.5, 12.5),
    iconSize: new L.Point(25, 25)
});

const externalTicketOfficeIcon = new L.Icon({
    iconUrl: require('../leaflet/icons/externalTicketOfficeIcon.png'),
    iconAnchor: new L.Point(25, 25),
    iconSize: new L.Point(50, 50)
});

const selectedExternalTicketOfficeIcon = new L.Icon({
    iconUrl: require('../leaflet/icons/selectedExternalTicketOfficeIcon.png'),
    iconAnchor: new L.Point(25, 25),
    iconSize: new L.Point(50, 50)
});

const ticketOfficeIcon = new L.Icon({
    iconUrl: require('../leaflet/icons/ticketOfficeIcon.png'),
    iconAnchor: new L.Point(25, 25),
    iconSize: new L.Point(50, 50)
});

const selectedTicketOfficeIcon = new L.Icon({
    iconUrl: require('../leaflet/icons/selectedTicketOfficeIcon.png'),
    iconAnchor: new L.Point(25, 25),
    iconSize: new L.Point(50, 50)
});

const lineInfoStopIcon = new L.Icon({
    iconUrl: require('../leaflet/icons/lineInfoStopIcon.png'),
    iconAnchor: new L.Point(7.5, 7.5),
    iconSize: new L.Point(15, 15)
});

const lineInfoSelectedStopIcon = new L.Icon({
    iconUrl: require('../leaflet/icons/lineInfoSelectedStopIcon.png'),
    iconAnchor: new L.Point(7.5, 7.5),
    iconSize: new L.Point(15, 15)
});

const routeOriginIcon = new L.Icon({
    iconUrl: require('../leaflet/icons/routeOriginIcon.png'),
    iconAnchor: new L.Point(15, 15),
    iconSize: new L.Point(30, 30)
});

const routeDestinationIcon = new L.Icon({
    iconUrl: require('../leaflet/icons/routeDestinationIcon.png'),
    iconAnchor: new L.Point(15, 15),
    iconSize: new L.Point(30, 30)
});

const vehicleIcon = new L.Icon({
    iconUrl: require('../leaflet/icons/vehicle.png'),
    iconAnchor: new L.Point(20, 10),
    iconSize: new L.Point(40, 20)
});

const clusterIcon = (cluster) => {
    let markerCount = cluster.getChildCount();
    let html = '<div>' + markerCount + '</div>';
    return L.divIcon({ html: html, className: 'marker-cluster', iconSize: L.point(50, 50), iconAnchor: L.point(25, 25) });
}

const ticketOfficeSvgPath = "M662 495h-324a40 40 0 0 1-40-40v-209a40 40 0 0 1 40-40h324a40 40 0 0 1 40 40v209a40 40 0 0 1-40 40z m-324-28h324a12 12 0 0 0 13-12v-25h-350v25a12 12 0 0 0 13 12z m324-234h-324a12 12 0 0 0-12 12v128h349v-127a12 12 0 0 0-13-13z m-162-362a479 479 0 1 0 479 479 480 480 0 0 0-479-479z m0 937a458 458 0 1 1 458-458 459 459 0 0 1-458 458z";

const createTicketOfficeMarkerIcon = (color) => L.divIcon({
    html: `<svg viewBox="0 0 1000 1000" width="40" height="40"><g transform="translate(0,850) scale(1,-1)"><circle cx="500" cy="350" r="479" fill="#ffffff"/><path fill="${color}" d="${ticketOfficeSvgPath}"/></g></svg>`,
    className: 'ticket-office-marker-icon',
    iconSize: L.point(40, 40),
    iconAnchor: L.point(20, 20)
});

export { stopIcon, selectedStopIcon, externalTicketOfficeIcon, selectedExternalTicketOfficeIcon, ticketOfficeIcon, selectedTicketOfficeIcon, lineInfoStopIcon, lineInfoSelectedStopIcon, routeOriginIcon, routeDestinationIcon, vehicleIcon, clusterIcon, createTicketOfficeMarkerIcon };
